import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxIconDirective } from './icon.directive';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  declarations: [PhxIconDirective],
  exports: [PhxIconDirective],
})
export class PhxIconModule { }